export {default} from './ConsumptionComponent';
